import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { DateFormat, Language } from '@nimbus-library/features/localization/models/enums/language.enum';
import { ILocalizationService } from '@nimbus-library/features/localization/services/i-localization.service';
import { WallboardSelectors } from '../../store/wallboard.selectors';

@Injectable({ providedIn: 'root' })
export class WallboardLocalizationService extends ILocalizationService {
  public constructor(private readonly store: Store) {
    super();
  }

  public loadUserLanguage(): Observable<Language | null> {
    const value = this.store.selectSnapshot(WallboardSelectors.language) as Language | null;
    return of(value);
  }

  public saveUserLanguage(): Observable<void> {
    return of(undefined);
  }

  public loadUserDateFormat(): Observable<DateFormat | null> {
    const value = this.store.selectSnapshot(WallboardSelectors.dateTimeFormat) as DateFormat | null;
    return of(value);
  }

  public saveUserDateFormat(): Observable<void> {
    return of(undefined);
  }
}
